import styles from './Panel.module.scss';

const Panel = ({ children }: React.PropsWithChildren) => {
  return <div className={styles.panel}>{children}</div>;
};

export default Panel;
